import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Search: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.188 0.0264114C8.4223 0.172163 6.81298 0.682427 5.35531 1.55867C4.52647 2.05691 3.92429 2.5287 3.22647 3.2265C2.77822 3.67475 2.53697 3.95075 2.1972 4.40401C0.267122 6.97871 -0.437398 10.2595 0.264506 13.404C0.897698 16.2406 2.64624 18.7259 5.11198 20.2938C5.77973 20.7184 6.67558 21.1487 7.43998 21.4121C9.24787 22.0349 11.2929 22.1656 13.1904 21.7796C14.872 21.4376 16.4202 20.722 17.796 19.6509L18.036 19.4641L20.16 21.5881L22.2841 23.712L22.998 22.9981L23.712 22.2841L21.588 20.1601L19.4641 18.036L19.6509 17.796C21.5851 15.3116 22.363 12.2257 21.8389 9.11689C21.608 7.74743 21.0681 6.34403 20.3073 5.13601C19.1806 3.34676 17.49 1.86344 15.6 1.00576C14.0917 0.321275 12.5625 -0.00728458 10.9345 0.00329942C10.6559 0.00512342 10.32 0.0155154 10.188 0.0264114ZM10.5782 2.01856C7.84095 2.13642 5.28471 3.53036 3.67198 5.78466C2.82903 6.96294 2.26738 8.39728 2.07665 9.85892C1.99882 10.4552 1.99294 11.4467 2.06369 12.036C2.29351 13.95 3.11518 15.7322 4.40287 17.1096C5.88646 18.6966 7.76525 19.6541 9.94798 19.9358C10.3658 19.9897 11.5583 19.9974 11.952 19.9487C13.0504 19.8127 13.9552 19.5532 14.892 19.1055C16.7345 18.2247 18.2247 16.7346 19.1054 14.892C19.5532 13.9553 19.8127 13.0504 19.9486 11.952C19.9974 11.5584 19.9897 10.3658 19.9358 9.94801C19.6034 7.37264 18.2898 5.15776 16.212 3.66925C14.8566 2.69828 13.1175 2.08969 11.52 2.02727C11.3418 2.02028 11.1474 2.0116 11.088 2.00792C11.0286 2.00428 10.7992 2.00905 10.5782 2.01856Z'
        fill={fill}
      />
    </svg>
  )
}

export default Search
